import { demoModeAtom } from '@/global-store';
import OfferContactForm from '@components/OfferContactForm';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

// Banner to offer users to buy a feature
export default function FeatureOfferBanner({
  product,
  beforeText = '',
  hidden = false,
  sx,
}) {
  const { t } = useTranslation();
  const [demoMode] = useAtom(demoModeAtom);

  if (hidden || demoMode) return null;

  return (
    <Grid size={12}>
      <Box
        sx={{
          bgcolor: 'secondary.main',
          borderRadius: 1.5,
          p: 2.5,
          ...sx,
        }}
      >
        <Typography
          variant='h2'
          sx={{
            color: 'black.main',
            mb: 3,
            fontWeight: 600,
          }}
        >
          {beforeText ? (
            <>
              {beforeText}
              <br />
              <br />
            </>
          ) : null}

          {t('featureOfferBoxCallToAction', { product })}
        </Typography>

        <OfferContactForm product={product} />
      </Box>
    </Grid>
  );
}
